import { IProjectConfig } from "../types";

/**
 * Generates a project filename from project config.
 */
export function generateProjectFilename(projectConfig: IProjectConfig): string {
  const { project_id, project_name, location, name_of_road } = projectConfig;

  const id = project_id || new Date().toISOString();
  const name = project_name || "Signify-project";
  const loc = location || "Signify-location";
  const road = name_of_road || "Signify-roadname";

  return `${id}-${name}-${loc}-${road}`;
}
